import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Paper,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  IconButton,
  Divider
} from '@mui/material';

import {
  Dashboard as DashboardIcon,
  RestaurantMenu,
  Fastfood,
  TuneOutlined,
  ArrowForward,
} from '@mui/icons-material';
import Notification from '@mui/icons-material/NotificationsActive';

const AdminNavigation = () => {
  const navigate = useNavigate();

  const adminPages = [
    {
      title: 'Dashboard',
      description: 'View statistics and overview of system activity',
      icon: <DashboardIcon fontSize="large" color="primary" />,
      path: '/admin',
      color: '#bbdefb' // light blue
    },
    {
      title: 'Manage Preferences & Filters',
      description: 'Add, update or delete categories like meal types, dietary preferences, and more',
      icon: <TuneOutlined fontSize="large" color="primary" />,
      path: '/admin/preferences',
      color: '#c8e6c9' // light green
    },
    {
      title: 'Manage Meal Ideas',
      description: 'Add or update meal suggestions with associated filters and tags',
      icon: <Fastfood fontSize="large" color="primary" />,
      path: '/admin/meals',
      color: '#ffecb3' // light amber
    },
    {
      title: 'Manage Notifications',
      description: 'Send notifications to users',
      icon: <Notification fontSize="large" color="primary" />,
      path: '/admin/notifications',
      color: '#ffecb3' // light amber
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h3" component="h1" fontWeight="bold" color="primary" gutterBottom>
          Admin Control Panel
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Select a section to manage your Kya Banega Aaj application
        </Typography>
        <Divider sx={{ mt: 2, mb: 4 }} />
      </Box>

      <Grid container spacing={3}>
        {adminPages.map((page) => (
          <Grid item xs={12} md={4} key={page.title}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6
                }
              }}
              onClick={() => navigate(page.path)}
            >
              <Box sx={{ 
                height: 120, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                bgcolor: page.color
              }}>
                <Box>
                  {page.icon}
                </Box>
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="h2" gutterBottom>
                  {page.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {page.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button 
                  size="small" 
                  color="primary" 
                  endIcon={<ArrowForward />}
                  onClick={() => navigate(page.path)}
                  sx={{ ml: 'auto' }}
                >
                  Go to {page.title.split(' ')[0]}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AdminNavigation;
